'use client';

import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next, useTranslation as useTranslationOrg } from 'react-i18next';

import { getOptions } from '~/shared/libs/i18n/settings';

if (typeof globalThis !== 'undefined') {
  globalThis.__i18next_supportNoticeShown = true;
}

i18next
  .use(initReactI18next)
  .use(resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`)))
  .init(getOptions());

export { useTranslationOrg as useTranslation };
export default i18next;
